module.exports = __webpack_public_path__ + "img/illey.ff1acf91.png";